import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const addComment = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	body: string,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('comment', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyComment')
		return null
	}
	try {
		const updated = await port.addComment(item.id, ctx.actorId, ctx.actorName, body)
		return updated
	} catch {
		notify.error('workItem.commentAddFailed')
		return null
	}
}

export { addComment }
